import React, { useEffect, useState } from 'react';
import {
  Grid,
  Card,
  CardContent,
  Typography,
  CircularProgress,
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Button, Dialog, DialogTitle, DialogContent } from '@mui/material';
import MembershipSubscribeForm from './MembershipSubscribeForm'; // new component
import {
  getDecryptedAccessToken,
  getDecryptedUserType
} from '../../Utils/LoginUserDetails.js/LoginUserSavedDetails';
import ApiServices from '../../Utils/ApiServices/ApiServices';

const AvailableMemberships = () => {
  const accessToken = getDecryptedAccessToken();
  const LoginUserType = getDecryptedUserType();
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);

  const handleOpenDialog = (plan) => {
    setSelectedPlan(plan);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedPlan(null);
  };
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchMembershipPlans = async () => {
    try {
      const endpoint =
        LoginUserType === 'Patient'
          ? '/apis/default/portal/membership'
          : '/apis/default/api/membership';

      const response = await ApiServices.get(endpoint, {
        Authorization: `Bearer ${accessToken}`,
      });

      const sortedPlans = (response.data || []).sort((a, b) =>
        a.category.localeCompare(b.category)
      );

      setPlans(sortedPlans);
    } catch (error) {
      console.error('Error fetching membership plans:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMembershipPlans();
  }, [accessToken]);

  // Group by category
  const groupedPlans = plans.reduce((acc, plan) => {
    if (!acc[plan.category]) acc[plan.category] = [];
    acc[plan.category].push(plan);
    return acc;
  }, {});

  return (
    <Box p={3}>
      <Typography variant="h4" fontWeight="bold" color="primary" gutterBottom>
        All Membership Plans
      </Typography>

      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 5 }}>
          <CircularProgress />
        </Box>
      ) : (
        Object.keys(groupedPlans).map((category) => (
          <Box key={category} sx={{ mb: 5 }}>
            <Typography variant="h6" color="secondary" sx={{ mb: 2, textTransform: 'capitalize' }}>
              {category ? category : "Single User"} Plans
            </Typography>

            <Grid container spacing={3}>
              {groupedPlans[category].map((plan) => (
                <Grid item xs={12} sm={6} md={4} key={plan.id}>
                  <Card sx={{ borderRadius: 3, boxShadow: 5, height: '100%' }}>
                    <CardContent>
                      <Typography variant="h6" gutterBottom color="primary">
                        {plan.plan_tier}
                      </Typography>

                      <Typography variant="subtitle2" color="text.secondary">
                        {plan.type_name}
                      </Typography>

                      <Divider sx={{ my: 2 }} />

                      <Typography variant="body2" fontWeight="bold" gutterBottom>
                        Benefits:
                      </Typography>
                      {plan.benefits?.length > 0 ? (
                        <List dense>
                          {plan.benefits.map((benefit, idx) => (
                            <ListItem key={idx} sx={{ pl: 0 }}>
                              <ListItemIcon sx={{ minWidth: 32 }}>
                                <CheckCircleIcon color="success" fontSize="small" />
                              </ListItemIcon>
                              <ListItemText primary={benefit} />
                            </ListItem>
                          ))}
                        </List>
                      ) : (
                        <Typography variant="body2" color="text.secondary">
                          No benefits added.
                        </Typography>
                      )}

                      <Divider sx={{ my: 2 }} />

                      <Typography variant="body2" fontWeight="bold" gutterBottom>
                        Age-Based Pricing:
                      </Typography>
                      {plan.age_based_pricing?.length > 0 ? (
                        <Paper elevation={0} sx={{ mt: 1, background: '#f9f9f9' }}>
                          <Table size="small">
                            <TableHead>
                              <TableRow>
                                <TableCell><strong>Min Age</strong></TableCell>
                                <TableCell><strong>Max Age</strong></TableCell>
                                <TableCell><strong>Price ($)</strong></TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {plan.age_based_pricing.map((tier, index) => (
                                <TableRow key={index}>
                                  <TableCell>{tier.min_age}</TableCell>
                                  <TableCell>{tier.max_age}</TableCell>
                                  <TableCell>$ {tier.price}</TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </Paper>
                      ) : (
                        <Typography variant="body2" color="text.secondary">
                          No age-based pricing available.
                        </Typography>
                      )}
                    </CardContent>
                     <Box textAlign="center" pb={2}>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => handleOpenDialog(plan)}
                      >
                        Subscribe
                      </Button>
                    </Box>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Box>
        ))
      )}
       <Dialog open={openDialog} onClose={handleCloseDialog} fullWidth maxWidth="sm">
        <DialogTitle>Subscribe to Plan</DialogTitle>
        <DialogContent>
          {selectedPlan && (
            <MembershipSubscribeForm
              plan={selectedPlan}
              onClose={handleCloseDialog}
            />
          )}
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default AvailableMemberships;
